var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarFormSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-12{fill:none}.cls-2{fill:#e8ecf0}.cls-10,.cls-4{fill:#bac0cd}.cls-5{fill:#eff3f6;stroke:#bac0cd;stroke-width:.68px;stroke-dasharray:22.81 .91 .91 1.82 5.47 .46}.cls-10,.cls-12,.cls-15,.cls-5{stroke-linecap:round}.cls-15,.cls-5{stroke-miterlimit:10}.cls-15,.cls-6{fill:#fff}.cls-7{fill:#753bbb}.cls-8{fill:#474e5e}.cls-9{fill:#8991a0}.cls-10,.cls-12{stroke:#fff;stroke-width:.81px;stroke-linejoin:round;stroke-dasharray:19.46 1.08 1.08 2.16}.cls-12{stroke:#e8ecf0;stroke-width:.54px}.cls-13{fill:#343a5c;opacity:.64}.cls-15{stroke-width:.7px;stroke:#8991a0;stroke-dasharray:14.99 .94 .47 2.34}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    transform: "translate(-1231 -6789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4480",
    fill: "none",
    d: "M0 0H200V110H0z",
    transform: "translate(1231 6789)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(1239 6789.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20795",
    d: "M12.081 91.956c-1.157-1.379-17.21-21.015-10.405-38.678C10.508 30.319 35.864 25.6 51.908 36.484c3.814 2.583 11.267 11.924 18.515 12.035C83.227 48.7 106.352-.157 135.375 0c19.265.1 36.04 19.21 36.373 39.151.241 14.812-12.442 23.144-8.239 34.938 2.962 8.332 11.8 14.96 18.987 17.284z",
    className: "cls-2",
    transform: "translate(-.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4516",
    fill: "#d4d8e0",
    d: "M0 0H175.822V0.87H0z",
    transform: "translate(8.183 91.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20796",
    d: "M14.57 96.53h5.8a2.009 2.009 0 0 1 2.009 2.009H12.57a2.009 2.009 0 0 1 2-2.009z",
    className: "cls-4",
    transform: "translate(-.934 -7.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20797",
    d: "M14.27 71.2h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.054A1.713 1.713 0 0 1 14.27 71.5z",
    className: "cls-4",
    transform: "translate(-1.06 -5.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20798",
    d: "M21.379 95.412H13.76l2-22.052h3.407z",
    className: "cls-4",
    transform: "translate(-1.022 -5.445)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2508",
    cx: 5.416,
    cy: 5.416,
    r: 5.416,
    className: "cls-5",
    transform: "translate(11.006 19.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20799",
    d: "M14.27 31.56h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.054a1.713 1.713 0 0 1-1.713-1.713z",
    className: "cls-4",
    transform: "translate(-1.06 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4517",
    d: "M0 0H1.805V36.688H0z",
    className: "cls-4",
    transform: "translate(15.617 30.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20800",
    d: "M96.3 96.53h5.814a2.009 2.009 0 0 1 2.009 2.009H94.3a2.009 2.009 0 0 1 2-2.009z",
    className: "cls-4",
    transform: "translate(-7.001 -7.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20801",
    d: "M96 71.2h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.054A1.713 1.713 0 0 1 96 71.5z",
    className: "cls-4",
    transform: "translate(-7.127 -5.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20802",
    d: "M103.109 95.412H95.49l2-22.052h3.41z",
    className: "cls-4",
    transform: "translate(-7.089 -5.445)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2509",
    cx: 5.416,
    cy: 5.416,
    r: 5.416,
    className: "cls-5",
    transform: "translate(86.669 19.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20803",
    d: "M96 31.56h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.054A1.713 1.713 0 0 1 96 31.856z",
    className: "cls-4",
    transform: "translate(-7.127 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4518",
    d: "M0 0H1.805V36.688H0z",
    className: "cls-4",
    transform: "translate(91.28 30.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4519",
    d: "M0 0H167.582V1.731H0z",
    className: "cls-4",
    transform: "translate(1.684 73.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4520",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(24.013 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4521",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(29.003 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4522",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(33.984 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4523",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(38.974 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4524",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(43.955 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20804",
    d: "M181.309 96.53h5.814a2.009 2.009 0 0 1 2.009 2.009H179.3a2.009 2.009 0 0 1 2.009-2.009z",
    className: "cls-4",
    transform: "translate(-13.311 -7.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20805",
    d: "M181 71.2h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.046A1.713 1.713 0 0 1 181 71.5z",
    className: "cls-4",
    transform: "translate(-13.437 -5.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20806",
    d: "M188.11 95.412h-7.61l2-22.052h3.407z",
    className: "cls-4",
    transform: "translate(-13.4 -5.445)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2510",
    cx: 5.416,
    cy: 5.416,
    r: 5.416,
    className: "cls-5",
    transform: "translate(165.36 19.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20807",
    d: "M181 31.56h6.48v.3a1.713 1.713 0 0 1-1.713 1.713h-3.046A1.713 1.713 0 0 1 181 31.856z",
    className: "cls-4",
    transform: "translate(-13.437 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4525",
    d: "M0 0H1.805V36.688H0z",
    className: "cls-4",
    transform: "translate(169.979 30.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4526",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(48.944 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4527",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(53.934 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4528",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(58.915 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4529",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(63.905 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4530",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(68.895 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4531",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(73.875 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4532",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(78.865 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4533",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(83.846 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4534",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(99.464 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4535",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(104.444 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4536",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(109.434 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4537",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(114.415 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4538",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(119.405 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4539",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(124.394 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4540",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(129.375 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4541",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(134.365 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4542",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(139.355 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4543",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(144.336 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4544",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(149.325 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4545",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(154.306 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4546",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(164.499 74.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4547",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(8.183 74.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2511",
    cx: 12.516,
    cy: 12.516,
    r: 12.516,
    className: "cls-6",
    transform: "translate(107.592 84.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2512",
    cx: 12.516,
    cy: 12.516,
    r: 12.516,
    className: "cls-6",
    transform: "translate(26.726 84.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20808",
    d: "M144.207 95.706l-1.231-.7.25-2.777.694-.861a.667.667 0 0 0 0-.805 19.237 19.237 0 0 0-5.212-5.092c-2.314-1.5-5.166-2.1-10.767-3.249a87.4 87.4 0 0 0-15.682-2h-3.583a75.987 75.987 0 0 0-10.517-6.48A49.991 49.991 0 0 0 87.9 69.479c-3.944-1.055-7.545-1.037-14.812-1a155.442 155.442 0 0 0-19.7 1.5l-1.759.25-1.592-.787a3.37 3.37 0 0 0-1.472-.343h-.056l.25 1.5-8.684.926a5.879 5.879 0 0 0-1.6.389l-3.7 1.444 2.75.231-13.4 5.369a2.083 2.083 0 0 1-.787.148h-1.906a.352.352 0 0 0-.278.555l.454.574.75 1.25-.75.25c-.62.259-.87.75-.75 1s.407.278.75.25l-1.361 1.945a1.25 1.25 0 0 0-.139 1.194l.25.62v5.5l-.185.065a.833.833 0 0 0-.574.8v.926l-.231.157a.611.611 0 0 0-.176.852l.157.241 5.555 1.4a2.435 2.435 0 0 1 .778.343l2.1 1.4c.352.241-2.49 2.879-2.064 2.9l2.99.13a12.137 12.137 0 0 1 24.264.343v.759l56.814 2.518a12.137 12.137 0 1 1 23.8-3.342 11.933 11.933 0 0 1-.824 4.388l1.657.074a4.555 4.555 0 0 0 4.129-2.657l.426-1.055 4.629-.13 1.129-4.74a1.916 1.916 0 0 0-.065-1.092 1.851 1.851 0 0 0-.46-.818z",
    className: "cls-7",
    transform: "translate(-1.418 -5.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20809",
    d: "M24.64 79.5l13.266-5.76.75.259L27.149 79z",
    className: "cls-8",
    transform: "translate(-1.83 -5.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20810",
    d: "M44.919 76.55c1.194-.62 6.656-3.175 8.332-3.462 2.555-.454 22.005-2.157 27.616-2.148 6.656 0 8.332.333 9.008.5 5.225 1.148 17.765 10.007 17.765 10.007-1.092 0-16.858-.352-28.523-1-13.618-.759-13.525-.713-17.516-1-5.555-.407-10.295-.833-13.766-1.176a22.757 22.757 0 0 1-2.87-1.185.305.305 0 0 1-.046-.537z",
    className: "cls-9",
    transform: "translate(-3.325 -5.266)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2513",
    cx: 10.656,
    cy: 10.656,
    r: 10.656,
    className: "cls-8",
    transform: "translate(28.679 86.245)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2514",
    cx: 5.018,
    cy: 5.018,
    r: 5.018,
    className: "cls-10",
    transform: "translate(34.53 91.679)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2515",
    cx: 10.656,
    cy: 10.656,
    r: 10.656,
    className: "cls-8",
    transform: "translate(109.508 86.245)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2516",
    cx: 5.018,
    cy: 5.018,
    r: 5.018,
    className: "cls-10",
    transform: "translate(115.359 91.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20811",
    d: "M107.592 81.417S95.048 72.558 89.826 71.41c-.722-.167-2.351-.491-9.008-.5-5.166 0-22.107 1.444-26.718 2.018l-1.12.139a63.607 63.607 0 0 0-8.063 3.481.305.305 0 0 0 0 .537 22.757 22.757 0 0 0 2.842 1.157l5.8.537 2.277-3.49a2.416 2.416 0 0 1 1.75-1.074c6.749-.722 12.433-1.305 16.969-1.852l1.083 7.888 3.425.194h.8l-2.722-8.332a30.366 30.366 0 0 1 6.554.148 22.58 22.58 0 0 1 6.758 1.759 68.585 68.585 0 0 1 6.249 3.5l.787.463a.7.7 0 0 1 .3.815L97 81.177c5.685.157 10.008.24 10.592.24z",
    className: "cls-8",
    transform: "translate(-3.323 -5.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20812",
    fill: "none",
    stroke: "#e8ecf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.27px",
    d: "M44.919 76.55c1.194-.62 6.656-3.175 8.332-3.462 2.555-.454 22.005-2.157 27.616-2.148 6.656 0 8.332.333 9.008.5 5.225 1.148 17.765 10.007 17.765 10.007-1.092 0-16.858-.352-28.523-1-13.618-.759-13.525-.713-17.516-1-5.555-.407-10.295-.833-13.766-1.176a22.757 22.757 0 0 1-2.87-1.185.305.305 0 0 1-.046-.537z",
    transform: "translate(-3.325 -5.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20813",
    d: "M51.937 79.56l-3.777 3.129 1.889 9.656",
    className: "cls-12",
    transform: "translate(-3.576 -5.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20814",
    d: "M116.55 81.85l2.259 1.509 19.515 2.25 3.5 1.5-5.749 2.5-1.75 1.25",
    className: "cls-12",
    transform: "translate(-8.653 -6.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20815",
    d: "M80.33 81.58l1 4.259.75 5.758v7.063l.25 3.194-.75 5.008",
    className: "cls-12",
    transform: "translate(-5.964 -6.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20816",
    d: "M112.5 82.39l1.5 5.758v13.1l.25 2.916-.75 2.759",
    className: "cls-12",
    transform: "translate(-8.352 -6.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20817",
    d: "M109.336 102.752l-.768-.333-39.29-3.027-12.507 1.028-.833-2.148a11.017 11.017 0 0 0-4.416-5.406l-1.278-.8a18.728 18.728 0 0 0-12.47-2.712l-.37.046a17.46 17.46 0 0 0-10.063 5l-.5.509-7.008-.809a.926.926 0 0 0-.2.546v.926l-.231.157a.611.611 0 0 0-.194.815l4.8 1.4.074.056.926.222a2.435 2.435 0 0 1 .778.343l2.1 1.4c.083.056 0 .259-.213.518l.676.472h.685a12.137 12.137 0 0 1 23.959.926l56.389 2.777a10.77 10.77 0 0 1-.046-1.906z",
    className: "cls-13",
    transform: "translate(-1.42 -6.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20818",
    d: "M28.652 103.886a12.13 12.13 0 0 1 .4-3.084 40.009 40.009 0 0 1-3.9-2.3l-6.138-1.389a.333.333 0 0 0-.426.278l-.324 2.49a.574.574 0 0 0-.259.759l1.25 2.685a1.518 1.518 0 0 0 .833.778l8.878 3.416a2.279 2.279 0 0 0 .268.083 12.035 12.035 0 0 1-.583-3.712z",
    className: "cls-8",
    transform: "translate(-1.333 -7.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20819",
    d: "M112.071 105.754l-39.633-3.064-16.83.287a12.3 12.3 0 0 1-.648 5.388l27.643.407h30.245a11.637 11.637 0 0 1-.777-3.018z",
    className: "cls-8",
    transform: "translate(-4.081 -7.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20820",
    d: "M153.848 99l-1.25 5.258-4.379.37s-1.3 1.25-1.805 1.241l-3.833-.056a11.933 11.933 0 0 1-.731 2.694h.852a4.242 4.242 0 0 0 .768-.074l8.184-1.685a1.852 1.852 0 0 0 1.416-1.444l.926-4.786a3.092 3.092 0 0 0-.148-1.518z",
    className: "cls-8",
    transform: "translate(-10.531 -7.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20821",
    d: "M141.917 93.571v.083a62.693 62.693 0 0 0-23.811-6.092l-2.777 2c-2.638-.435-5.314-.861-8.008-1.25a370.711 370.711 0 0 0-45.8-3.7H57.08a51.075 51.075 0 0 1 10.767 8.258 52.067 52.067 0 0 1 4.749 5.5l5.258.509 33.328 2.5 1.092.148a12.137 12.137 0 0 1 24.181 1.324h8.017l1.759-6.258.074-3z",
    className: "cls-13",
    transform: "translate(-4.238 -6.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20822",
    d: "M140.61 88.53l2.5-1h1.111A13.118 13.118 0 0 1 149.6 89a1.444 1.444 0 0 1 .7.824l.444 1.333H147.5a2.231 2.231 0 0 1-.778-.148z",
    className: "cls-8",
    transform: "translate(-10.439 -6.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20823",
    d: "M21.086 80.55l.444.574.75 1.25-.75.25c-.62.259-.861.75-.75 1s.407.278.75.25l-1.361 1.944a1.278 1.278 0 0 0-.139 1.194l.25.62v5.5l-.18.068a.629.629 0 0 0-.194.093l6.749.722c.241-.333.241-.167.5-.5a23.459 23.459 0 0 1 8.645-6.633z",
    className: "cls-13",
    transform: "translate(-1.479 -5.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20824",
    d: "M110.918 78.9c.685.518 1.639 1.268 2.777 2.25h1.37a.278.278 0 0 0 .093-.537l-.565-.222h-.148a75.987 75.987 0 0 0-10.517-6.48 62.09 62.09 0 0 0-7.045-3.231l-.583.352c.444.157 1.148.417 2 .75a53.1 53.1 0 0 1 12.618 7.118z",
    className: "cls-8",
    transform: "translate(-7.15 -5.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20825",
    d: "M20.989 83.086l1.148-.926 3.573.676a3.776 3.776 0 0 1 .833.259l2.357 1.074-2.463 1.444a2.064 2.064 0 0 1-2.25-.12l-1.518-1.12a2.167 2.167 0 0 0-.4-.241l-1.278-.574a.278.278 0 0 1 0-.472z",
    className: "cls-8",
    transform: "translate(-1.549 -6.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20826",
    d: "M52.1 85.37h4.009a1.5 1.5 0 0 1 1.49 1.509h-7a1.5 1.5 0 0 1 1.5-1.509z",
    className: "cls-2",
    transform: "translate(-3.757 -6.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20827",
    d: "M84.537 87h4.018a1.5 1.5 0 0 1 1.5 1.5H83a1.5 1.5 0 0 1 1.537-1.5z",
    className: "cls-2",
    transform: "translate(-6.162 -6.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20828",
    d: "M103.029 77.53h.611a4.508 4.508 0 0 1 4.508 4.508h-4.694a2.314 2.314 0 0 1-2.314-2.314v-.3a1.852 1.852 0 0 1 1.889-1.9z",
    className: "cls-2",
    transform: "translate(-7.509 -5.755)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4548",
    width: 37.503,
    height: 42.095,
    fill: "#eff3f6",
    stroke: "#753bbb",
    strokeDasharray: "23.42 0.94 0.94 1.87 5.62 0.47",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "0.7px",
    rx: 3.19,
    transform: "translate(114.424 21.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2517",
    cx: 3.101,
    cy: 3.101,
    r: 3.101,
    className: "cls-7",
    transform: "translate(147.9 18.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4549",
    d: "M0 0H0.528V3.305H0z",
    className: "cls-6",
    transform: "rotate(46.89 52.274 185.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4550",
    d: "M0 0H0.528V3.305H0z",
    className: "cls-6",
    transform: "rotate(136.89 71.661 41.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_61",
    d: "M0 0L21.681 0",
    className: "cls-15",
    transform: "translate(121.802 53.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_62",
    d: "M0 0L21.681 0",
    className: "cls-15",
    transform: "translate(121.904 56.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20829",
    d: "M142.631 29.747a9.98 9.98 0 1 0 1.777 0 9.5 9.5 0 0 0-1.777 0zm6.267 7.684l-5.906 5.842a.926.926 0 0 1-1.324 0l-3.481-3.324a.956.956 0 1 1 1.333-1.37l2.777 2.694 5.249-5.194a.949.949 0 0 1 1.333 1.352z",
    className: "cls-9",
    transform: "translate(-9.914 -2.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4551",
    d: "M0 0H0.87V16.914H0z",
    className: "cls-4",
    transform: "translate(159.509 74.46)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarFormSuccess);
export default __webpack_public_path__ + "static/media/car-form-success.6ad6da83cb16932bfe1457ba135ba721.svg";
export { ForwardRef as ReactComponent };